<div class="select_wrap" (click)="breakDownSelect()" [ngClass]="{ active_cuenta: breakDown }">
	<ul class="default_option">
		<li>
			<div class="option">
				<h4 *ngIf="itemSelected === undefined || itemSelected === null; else selected">Seleccione una cuenta</h4>
			</div>
		</li>
		<ng-template #selected>
			<h5>
				N° <strong>{{ itemSelected!.title }}</strong>
			</h5>
			<p *ngIf="!showAdditionalData">{{ itemSelected!.subTitle }}</p>
			<p *ngIf="showAdditionalData">
				{{ itemSelected!.subTitle }} ({{ itemSelected!.symbolCoin }} {{ availableBalanceFormatted(itemSelected!) }})
			</p>
		</ng-template>
	</ul>

	<ul class="select_ul">
		<li *ngFor="let item of items" (click)="change(item)">
			<div class="option">
				<h5>
					N° <strong>{{ item.title }}</strong>
				</h5>
				<p *ngIf="!showAdditionalData">{{ item.subTitle }}</p>
				<p *ngIf="showAdditionalData">
					{{ item.subTitle }} ({{ item.symbolCoin }} {{ availableBalanceFormatted(item!) }})
				</p>
			</div>
		</li>
	</ul>
</div>
